import { cloneDeep, get, set } from 'lodash';
import { AUSGABE_KATEGORIE, KOSTEN_POSITION, ZAHLUNGSWEISE } from '../../../../../lib/constants/constant';

// import schemas
import KostenpositionSchema from '../../../../../lib/paths/kostenposition_FULL_Paths.json';
import NachweisPositionsSchema from '../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchema.attributes;
const NP_P = NachweisPositionsSchema.attributes;
const KP_P = KostenpositionSchema.attributes;

export const executeEmobLisVNFormulas = (application: any, alleVerwendungsnachweise?: any[]) => {
	let appCopy = cloneDeep(application);
	let result: any = [];

	let calculatedGesamt = calculateGesamt(appCopy);
	result.push(...calculatedGesamt);
	for (let ele of calculatedGesamt) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	const zahlungsWeise = get(appCopy, VN_P.Foerderantrag.schema.attributes.Foerderprogramm.schema.attributes.Konfiguration_Zahlungsweise.path);

	if (zahlungsWeise === ZAHLUNGSWEISE.Nachschus) {
		let calculatedAbrufDaten = calculateAbruf(appCopy);
		result.push(...calculatedAbrufDaten);
		for (let ele of calculatedAbrufDaten) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	let calculatedHaushaltDaten = calculateHaushalt(appCopy, alleVerwendungsnachweise || []);
	result.push(...calculatedHaushaltDaten);
	for (let ele of calculatedHaushaltDaten) {
		set(appCopy, get(ele, 'path'), get(ele, 'value'));
	}

	return result;
};

function calculateGesamt(application: any) {
	let result: any = [];

	const nachgewieseneKostenPath = VN_P.Allgemein_Nachgewiesene_Kosten.path;
	const allNachweisPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	const summeAusgabe = allNachweisPositions
		.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Ausgabe)
		.reduce((sum: any, eachNachweis: any) => sum + parseFloat(get(eachNachweis, NP_P.Allgemein_Ausgaben_Kosten.path, '0')), 0);

	// Gesamt Einnahme wird aktuell nicht benötigt
	// Kann gelöscht werden, wenn es sicher ist, dass es nicht gebraucht wird
	// const gesamtEinnahme = allNachweisPositions
	// 	.filter((ele: any) => get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme)
	// 	.reduce((sum: any, eachNachweis: any) => sum + parseFloat(get(eachNachweis, NP_P.Allgemein_Ausgaben_Kosten.path, '0')), 0);

	const nachgewieseneKosten = summeAusgabe > 0 ? summeAusgabe : 0;

	result.push({
		path: nachgewieseneKostenPath,
		value: !isNaN(nachgewieseneKosten) ? nachgewieseneKosten.toFixed(2) : 0,
	});
	return result;
}

function calculateAbruf(application: any) {
	let result: any = [];

	const allKostenPositions = get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []);
	const allNachweisPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	const bewilligteFoerderung = get(application, VN_P.Foerderantrag.schema.attributes.Bewilligung_Bewilligte_Zuwendung.path, 0);

	// Summe berechnen
	const summeAusgaben = Number(get(application, VN_P.Allgemein_Nachgewiesene_Kosten.path, 0));
	const summeEinnahmen = allNachweisPositions
		.filter((eachNachweis: any) => get(eachNachweis, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Einnahme)
		.reduce((sum: any, eachNachweis: any) => {
			return sum + parseFloat(get(eachNachweis, NP_P.Allgemein_Ausgaben_Kosten.path, '0'));
		}, 0);

	const kalkulationBlock = get(application, VN_P.Block_1.path, []);
	const calculateKalkulationBlock_New = transformAnrufKalkulationBlock(kalkulationBlock, summeAusgaben, summeEinnahmen);

	const gesamtMaxFoerderung = getGesamtMaxFoerderung(application, allNachweisPositions, allKostenPositions, bewilligteFoerderung);

	// const zuwendungAnteil = summeEinnahmen > summeAusgaben ? 0 : summeAusgaben - summeEinnahmen;

	result.push(
		// Förderquote Ausgaben Block 2
		{
			path: VN_P.Block_1.path,
			value: calculateKalkulationBlock_New,
		},
		// Förderquote Ausgaben (Tatsächlich getätigte Ausgaben Gesamt)
		{
			path: VN_P.Kalkulation_Mittelabruf_Foerderquote_47_Ausgaben_Block_2_Zelle_3.path,
			value: !isNaN(summeAusgaben) ? summeAusgaben.toFixed(2) : 0,
		},
		// Förderquote Ausgaben (Zuwendung anteilig Gesamt)
		{
			path: VN_P.Kalkulation_Mittelabruf_Foerderquote_47_Ausgaben_Block_2_Zelle_4.path,
			value: !isNaN(gesamtMaxFoerderung) ? gesamtMaxFoerderung.toFixed(2) : 0,
		},
		// Ermittlungs Beträge
		// Bewilligte Zuwendung wird beim erstellen schon festgelegt. Braucht man hier nicht nochmal zu berechnen
		// Zuwendungsfähige Ausgaben
		{
			path: VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendungsfaehige_Ausgaben.path,
			value: !isNaN(summeAusgaben) ? summeAusgaben.toFixed(2) : 0,
		},
		// Zuwendungs anteilig
		{
			path: VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path,
			value: !isNaN(gesamtMaxFoerderung) ? gesamtMaxFoerderung.toFixed(2) : 0,
		},
		// abzüglich bereits abgerufenen Zuwendungen im gleichen Projektjahr wird beim erstellen schon festgelegt. Braucht man hier nicht nochmal zu berechnen
		// Anforderungsbetrag
		{
			path: VN_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path,
			value: !isNaN(gesamtMaxFoerderung) ? gesamtMaxFoerderung.toFixed(2) : 0,
		}
	);
	return result;
}

function calculateHaushalt(application: any, alleVerwendungsnachweise: any[]) {
	let result: any = [];

	// Aktuelle Verwendungsnachweis Daten
	const aktuellNachgewieseneKostenPath = VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendungsfaehige_Ausgaben.path;
	const aktuellNachgewieseneKosten = parseFloat(get(application, aktuellNachgewieseneKostenPath, '0')) || 0;

	const aktuelleZuwendungAnteilPath = VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path;
	const aktuelleZuwendungAnteil = parseFloat(get(application, aktuelleZuwendungAnteilPath, '0')) || 0;

	// Berechne SummeAusgaben: Summe aller bisherige Allgemein_Anerkannte_Kosten
	const bisherigeNachgewieseneKosten = alleVerwendungsnachweise.reduce((sum: number, vn: any) => {
		const anerkannteKosten = parseFloat(get(vn, VN_P.Allgemein_Anerkannte_Kosten.path, '0')) || 0;
		return sum + anerkannteKosten;
	}, 0);

	const bisherigeNachgewieseneKostenFinal = bisherigeNachgewieseneKosten + aktuellNachgewieseneKosten;

	// Berechne SummeZuwendung: Summe aller Allgemein_Anerkannter_Foerderanteil
	const summeZuwendung = alleVerwendungsnachweise.reduce((sum: number, vn: any) => {
		const anerkannterFoerderanteil = parseFloat(get(vn, VN_P.Allgemein_Anerkannter_Foerderanteil.path, '0')) || 0;
		return sum + anerkannterFoerderanteil;
	}, 0);

	const summeZuwendungFinal = summeZuwendung + aktuelleZuwendungAnteil;

	// Füge die berechneten Werte zum Result hinzu
	result.push(
		{
			path: VN_P.Summe_Ausgaben_im_Betrachteten_Haushaltsjahr.path,
			value:
				!isNaN(bisherigeNachgewieseneKostenFinal) && isFinite(bisherigeNachgewieseneKostenFinal) ?
					bisherigeNachgewieseneKostenFinal.toFixed(2)
				:	'0.00',
		},
		{
			path: VN_P.Summe_Zuwendung_im_Betrachteten_Haushaltsjahr.path,
			value: !isNaN(summeZuwendungFinal) && isFinite(summeZuwendungFinal) ? summeZuwendungFinal.toFixed(2) : '0.00',
		}
	);

	return result;
}

/*
 ***************************************************************************************************************
 * ************************ HELPER FUNCTIONS *******************************************************************
 * *************************************************************************************************************
 */

function transformAnrufKalkulationBlock(data: any[], nachgewieseneKosten: number, nachgewieseneEinnahmen: number) {
	return data.map((eachEle: any) => {
		// const foerderQuote = get(eachEle, 'Zelle_2', 0);
		const getaetigteAusgabe = nachgewieseneKosten;
		const zuwendungAnteilig = getaetigteAusgabe - nachgewieseneEinnahmen;

		return {
			...eachEle,
			Zelle_3: !isNaN(Number(getaetigteAusgabe)) ? Number(getaetigteAusgabe).toFixed(2) : 0,
			Zelle_4: !isNaN(Number(zuwendungAnteilig)) ? Number(zuwendungAnteilig).toFixed(2) : 0,
		};
	});
}

function getGesamtMaxFoerderung(application: any, allNachweisPosition: any[], allKostenPositions: any[], bewilligteFoerderung: number) {
	// Bewilligte Förderquote und Förderung lesen
	const bewilligteFoerderquote = get(application, VN_P.Foerderantrag.schema.attributes.Bewilligung_Foerderquote_Gesamt.path, 0) / 100; // In Dezimal umwandeln

	const kategorien = [AUSGABE_KATEGORIE.LadeTankInfrastruktur, AUSGABE_KATEGORIE.NetzanschlussUndErdarbeiten, AUSGABE_KATEGORIE.Energiespeicher];

	// Gruppierung für NP (Mittelabruf)
	const gruppiertNP: { [key: string]: number } = {};
	allNachweisPosition
		.filter((np) => get(np, NP_P.Allgemein_Kostenart.path) === KOSTEN_POSITION.Ausgabe)
		.forEach((np) => {
			const kostenpositionId = get(np, `${NP_P.Allgemein_Kostenposition.path}.id`);
			const kostenposition = allKostenPositions.find((kp) => kp.id === kostenpositionId);
			if (kostenposition) {
				const kategorie = get(kostenposition, KP_P.Allgemein_Ausgabekategorie.path);
				if (kategorie && kategorien.includes(kategorie)) {
					if (!gruppiertNP[kategorie]) gruppiertNP[kategorie] = 0;
					gruppiertNP[kategorie] += parseFloat(get(np, NP_P.Allgemein_Ausgaben_Kosten.path, '0')) || 0;
				}
			}
		});

	// Berechnung für jede Kategorie
	let foerderungLadeTank = (gruppiertNP[AUSGABE_KATEGORIE.LadeTankInfrastruktur] || 0) * bewilligteFoerderquote;

	// Netzanschluss mit Standort-Logik
	let foerderungNetzanschluss = (gruppiertNP[AUSGABE_KATEGORIE.NetzanschlussUndErdarbeiten] || 0) * bewilligteFoerderquote;
	if (foerderungNetzanschluss > 0) {
		// Standorte zählen
		const standorte = new Set<string>();
		allNachweisPosition.forEach((np) => {
			const kostenpositionId = get(np, `${NP_P.Allgemein_Kostenposition.path}.id`);
			const kostenposition = allKostenPositions.find((kp) => kp.id === kostenpositionId);
			if (kostenposition) {
				const kategorie = get(kostenposition, KP_P.Allgemein_Ausgabekategorie.path);
				if (kategorie === AUSGABE_KATEGORIE.NetzanschlussUndErdarbeiten) {
					const standortId = get(np, NP_P.Allgemein_Standort_Group_ID.path);
					if (standortId) standorte.add(standortId);
				}
			}
		});
		const anzahlStandorte = standorte.size;
		const maxNetzanschluss = 10000 * anzahlStandorte;
		foerderungNetzanschluss = Math.min(foerderungNetzanschluss, maxNetzanschluss);
	}

	// Energiespeicher mit max. 10.000€ Deckelung
	let foerderungEnergiespeicher = (gruppiertNP[AUSGABE_KATEGORIE.Energiespeicher] || 0) * bewilligteFoerderquote;
	foerderungEnergiespeicher = Math.min(foerderungEnergiespeicher, 10000);

	const gesamtMaxFoerderung = foerderungLadeTank + foerderungNetzanschluss + foerderungEnergiespeicher;

	// Begrenzung auf bewilligte Förderung
	const anzuzeigendeMaxFoerderung = Math.min(gesamtMaxFoerderung, bewilligteFoerderung);

	return anzuzeigendeMaxFoerderung;
}
